
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAssociatedTargetAisSelectedIec as ObiAssociatedTargetAisSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-associated-target-ais-selected-iec.js';
 
 
 

 
 export const ObiAssociatedTargetAisSelectedIec = createComponent({
   react: React,
   tagName: 'obi-associated-target-ais-selected-iec',
   elementClass: ObiAssociatedTargetAisSelectedIecElement,
   events: {
     
   }
  });
 
 